document.addEventListener("DOMContentLoaded", function(event) {
    
    let vendors = document.querySelectorAll('.grid-product__vendor');
    let titles = document.querySelectorAll('.grid-product__title--clamp');
    let prices = document.querySelectorAll('.grid-product__price');
    
    if (vendors.length) {
    let intervalId = setInterval(function() {
        let maxHeight = 0;

        vendors.forEach(function(vendor) {
        let height = vendor.clientHeight;
        maxHeight = Math.max(maxHeight, height);
        });

        vendors.forEach(function(vendor) {
        vendor.style.height = maxHeight + 'px';
        });
    }, 200);

    setTimeout(function() {
        clearInterval(intervalId);
    }, 3000);
    };
    
    if (titles.length) {
        let intervalIdTitle = setInterval(function() {
            let maxHeight = 0;
    
            titles.forEach(function(title) {
            let height = title.clientHeight;
            maxHeight = Math.max(maxHeight, height);
            
            });
    
            titles.forEach(function(title) {
                title.style.height = maxHeight + 'px';
            });
        }, 200);
        setTimeout(function() {
            clearInterval(intervalIdTitle);
        }, 3000);
    }

    if (prices.length) {
        let intervalIdPrice = setInterval(function() {
            let maxHeight = 0;
    
            prices.forEach(function(price) {
            let height = price.clientHeight;
            maxHeight = Math.max(maxHeight, height);
            
            });
    
            prices.forEach(function(price) {
                price.style.height = maxHeight + 'px';
            });
        }, 200);
        setTimeout(function() {
            clearInterval(intervalIdPrice);
        }, 3000);
    }

    /* Dynamic percentage calculate from variants */
    let percentageBadge = document.querySelector('.product-block--price .grid-product__tag--sale');
    let variantBtns = document.querySelectorAll('.variant-input.variation');
    variantBtns.forEach(function(variantBtn){
        variantBtn.addEventListener('click', function(e){
            setTimeout(function(){
                let priceField = document.querySelector('.product__price.product__price--compare');
            if (priceField) {
                let priceSale = document.querySelector('.product__price.on-sale').textContent;
                let cleanPrice = priceField.textContent.replace(/[\.,a-zA-Z]/g, '');
                let cleanSale = priceSale.replace(/[\.,a-zA-Z]/g, '');
                let percentageCalc = Math.round((cleanPrice - cleanSale) * 100 / cleanPrice);
                let customSavedClass = "custom-saved";
                let percentageText = `Spar: <span class="${customSavedClass}">${percentageCalc}%</span>`;
                percentageBadge.innerHTML  = percentageText;
            };
            },100)
        });
    });
    setTimeout(function(){
        let priceField = document.querySelector('.product__price.product__price--compare');
    if (priceField) {
        let priceSale = document.querySelector('.product__price.on-sale').textContent;
        let cleanPrice = priceField.textContent.replace(/[\.,a-zA-Z]/g, '');
        let cleanSale = priceSale.replace(/[\.,a-zA-Z]/g, '');
        let percentageCalc = Math.round((cleanPrice - cleanSale) * 100 / cleanPrice);
        let customSavedClass = "custom-saved";
        let percentageText = `Spar: <span class="${customSavedClass}">${percentageCalc}%</span>`;
        percentageBadge.innerHTML  = percentageText;
    };
    },100)

    function dynamicBadge() {
        let badges = document.querySelectorAll('.grid-product__tag--sale');
        if (badges) {
            badges.forEach(function(badge){
                let parentEle = badge.parentNode;
                let comparePrice = parentEle.querySelector('.grid-product__price--original').textContent;
                let cleanCompare = comparePrice.replace(/[\.,a-zA-Z]/g, '');
                let salePrice = parentEle.querySelector('.grid-pricing').textContent;
                let cleanSale = salePrice.replace(/[\.,a-zA-Z]/g, '');
                let percentageCalc = Math.round((cleanCompare - cleanSale) * 100 / cleanCompare);
                let customSavedClass = "custom-saved";
                let percentageText = `Spar: <span class="${customSavedClass}">${percentageCalc}%</span>`;
                badge.innerHTML  = percentageText;
            })
        }
    }
    dynamicBadge();

    // Loop through all grid items
    let gridItems = document.querySelectorAll(".grid__item.grid-product");

    gridItems.forEach((gridItem, gridIndex) => {

        let linkedItems = gridItem.querySelectorAll(".linked-products__item");
        let mainImage = gridItem.querySelector(".main-product-image");
        let linkedImages = gridItem.querySelectorAll(".linked-product__image");

        // Only proceed if linked images exist
        if (linkedImages.length > 0 && linkedItems.length > 0) {
        linkedItems.forEach((item, itemIndex) => {

            item.addEventListener("mouseenter", () => {
            const index = item.getAttribute("data-image-index");

            // Hide all linked images
            linkedImages.forEach((img, imgIndex) => {
                img.style.display = "none";
            });

            if (mainImage) {
                mainImage.style.display = "none";
            }

            // Show the corresponding linked product image
            const linkedImage = gridItem.querySelector(
                `.linked-product-image--${index}`
            );
            if (linkedImage) {
                linkedImage.style.display = "block";
            } else {
                console.error(`No linked image found for index: ${index}`);
            }
            });

            item.addEventListener("mouseleave", () => {

            // Hide all linked product images and show the main image
            linkedImages.forEach((img, imgIndex) => {
                img.style.display = "none";
            });

            if (mainImage) {
                mainImage.style.display = "block";
            }
            });
        });
        } else {
        console.warn(`Grid item ${gridIndex + 1} skipped: No linked images or linked items found`);
        }
    });

});